export type MobileBrowserPlatform = 'android' | 'ios' | 'unknown';

const X_IN_APP_BROWSER_PATTERNS = [
	/Twitter/i,
	/TwitterAndroid/i,
	/Twitter for iPhone/i,
	/Twitter for iPad/i,
];

export function getMobileBrowserPlatform(
	userAgent = getNavigatorUserAgent()
): MobileBrowserPlatform {
	if (/Android/i.test(userAgent)) return 'android';
	if (/iPhone|iPad|iPod/i.test(userAgent)) return 'ios';
	return 'unknown';
}

export function isMobileUserAgent(userAgent = getNavigatorUserAgent()): boolean {
	return /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
}

export function isXInAppBrowser(userAgent = getNavigatorUserAgent()): boolean {
	return (
		isMobileUserAgent(userAgent) &&
		X_IN_APP_BROWSER_PATTERNS.some((pattern) => pattern.test(userAgent))
	);
}

export function buildAndroidExternalBrowserIntentUrl(url: string): string {
	const parsed = new URL(url);
	const path = `${parsed.pathname}${parsed.search}`;

	return `intent://${parsed.host}${path}#Intent;scheme=${parsed.protocol.replace(':', '')};package=com.android.chrome;S.browser_fallback_url=${encodeURIComponent(
		url
	)};end`;
}

export function openCurrentPageInExternalBrowser(): void {
	if (typeof window === 'undefined') return;

	const url = window.location.href;
	const platform = getMobileBrowserPlatform();

	if (platform === 'android') {
		window.location.href = buildAndroidExternalBrowserIntentUrl(url);
	}
}

function getNavigatorUserAgent(): string {
	if (typeof navigator === 'undefined') return '';
	return navigator.userAgent;
}
